<template>
  <q-page>
    <div class="pageContent">  
      <div class="row">
        <div class="col q-table-title text-weight-bold">
          {{$t('global.GenerateNewMilestone')}}
        </div>
      </div>
      <div class="row">
        <div class="col content">
          <q-input v-model="name" :label="$t('global.NewMilestoneName')" />
        </div>
        <div class="col content"> 
          <q-select
            :label="$t('global.SelectAlert')"
            v-model="alertId"
            :options="alertOptions"
            ref="alert"
            emit-value map-options
          />
        </div>
        <div class="col content">
          <q-select
            :label="$t('global.SelectOwner')"
            v-model="userId"
            :options="ownerOptions"
            emit-value map-options
          />
        </div>   
      </div>
      
      <div class="row">
        <div class="col content">
          <q-input type="number" v-model="baseline" :label="$t('global.GoalBaseLine')" />      
        </div>
        <div class="col content">
          <q-radio v-model="reduce" :val="true" :label="$t('global.Reduce')" />
          <q-radio v-model="reduce" :val="false" :label="$t('global.Increase')" />  
        </div>
        <div class="col content">
          <q-input type="number" v-model="percent" :label="$t('global.Percent')" prefix="%"/>      
        </div>
        <div class="col content">
          <q-input type="number" v-model="goal" :label="$t('global.ReductionOrAddition')" />      
        </div>
      </div>
      <div class="row">
        <div class="col content">
          <q-radio v-model="genType" val="m" :label="$t('global.Month')" />&nbsp;
          <q-radio v-model="genType" val="w" :label="$t('global.Week')" />  
        </div>
        <div class="col content">
          <q-input type="number" v-model="times" :label="$t('global.Xtimes')" :min="1" :max="52" />      
        </div>
      </div>
      <div class="row">
        <div class="col content">
          <DateInput :date.sync="dateFrom" :label="$t('global.StartingAt')"></DateInput>
        </div>
        <div class="col content">
          <q-btn :disable="!isReady" class="button float-right" @click="generateMileStones()" color="primary" :label="btnText" />
        </div>
      </div>
      <div class="row">
        <div class="col q-pa-xs">
          <q-select
            :label="$t('global.SelectMilestone')"
            v-model="mileStoneId"
            :options="mileStoneOptions"
            ref="alert"
            emit-value map-options
          />
        </div>
        <div class="col q-pa-xs">
          <q-btn v-if="mileStoneId" class="button" @click="deleteMilestone" color="secondary" :label="$t('global.Delete')" />
        </div>
      </div>
      <div class="row">
        <div class="col">
          <q-table
          :data="Milestone"
          :columns="columnsSchedule"
          row-key="MileStoneDetailID"
          :dense="true"
          selection="single"
          :selected.sync="selectedRows"
          :pagination.sync="paginationControl" 
          >

        <template slot="top-selection" slot-scope="props" >
          <div class="q-table-title">Milestone Details</div>
          <div v-if="selectedRows">
            <q-btn color="secondary" flat :label="$t('global.Edit')" @click="editMilestoneDetail" />
          </div>
          <div>
            <q-btn color="secondary" flat :label="$t('global.Delete')" @click="deleteMilestoneDetail" />
          </div>
        </template>
        <q-td slot="body-cell-IsHourlyWage" slot-scope="props" :props="props">
          <q-checkbox v-model="props.row.IsHourlyWage" disable  />
        </q-td>
        <q-td slot="body-cell-IsActive" slot-scope="props" :props="props">
          <q-checkbox v-model="props.row.IsActive" disable  />
        </q-td>

        <q-td slot="body-cell-Status" slot-scope="props" :props="props">
          <q-btn v-if="checkOverdue(props.row)" color="primary" flat round icon="check_circle"  />
          <q-btn v-if="!checkOverdue(props.row)" color="negative" flat round icon="highlight_off"  />
        </q-td>
  
        </q-table>
        </div>

        <q-dialog v-model="editDialog" persistent>
          <q-card >
            <q-card-section class="row items-center">
              <span class="q-ml-sm q-table-title text-weight-bold">Edit Milestone</span>
            </q-card-section>
            <q-card-section>
              <DateInput class="pageContent" :date.sync="editStart" :label="$t('global.Starting')"></DateInput>
              <DateInput class="pageContent" :date.sync="editEnding" :label="$t('global.Ending')"></DateInput>       
              <q-input type="number" v-model="editGoal" :label="$t('global.Goal')" />
            </q-card-section>
            <q-card-actions align="right">
              <q-btn flat :label="$t('global.Cancel')" color="primary" v-close-popup />
              <q-btn flat :label="$t('global.Save')" @click="updateMilestoneDetail" color="primary" v-close-popup />
            </q-card-actions>
          </q-card>
        </q-dialog>

      </div>
    </div>
  </q-page>
</template>

<script>
import { date } from 'quasar'
import axios from 'axios'
import qs from 'qs'
export default {
  name: 'User',
  components: {
    //List,
  },
  data: function () {
    return {
      form: {
        SessionId: null,
      },
      dateFrom: this.moment(),
      times: 12,
      genType: "m",
      baseline: null,
      alertId: null,
      userId: null,
      percent: null,
      reduce: true,
      goal: null,
      name: "",
      mileStoneId: null,
      mileStoneOptions: [],
      editDialog: false,
      editStart: null,
      editEnding: null,
      editGoal: null,
      alertOptions: [],
      ownerOptions: [],
      Milestone:[],
      selectedRows: [], 
      columnsSchedule: [
      {
        name: 'MilestoneName',
        required: true,
        label: this.$t('global.Milestone'),
        align: 'left',
        field: 'MilestoneName',
        sortable: false
      },
      {
        name: 'AlertName',
        required: true,
        label: this.$t('global.Alert'),
        align: 'left',
        field: 'AlertConfigName',
        sortable: false
      },
      {
        name: 'Start',
        required: true,
        label: this.$t('global.Starting'),
        align: 'right',
        field: 'Start',
        sortable: true,
        format: val => this.dateFormat(val)
      },
      {
        name: 'End',
        required: true,
        label: this.$t('global.Ending'),
        align: 'right',
        field: 'Ending',
        sortable: true,
        format: val => this.dateFormat(val)
      },
      {
        name: 'Goal', 
        required: true,
        label: this.$t('global.Goal'),align: 'right',
        field: 'Goal',sortable: true,
        //format: val => round(val,2)
      },
      {
        name: 'Real', 
        required: true,
        label: this.$t('global.Real'),align: 'right',
        field: 'Real',sortable: true,
        //format: val => round(val,2)
      }  
      ],
      paginationControl: { rowsPerPage: 10, page: 1 },
    }
  },
  methods: {
    generateMileStones(){
      this.form.MilestoneName = this.name
      this.form.DateFrom = this.dateFrom.toISOString()
      this.form.Goal = this.baseline
      this.form.AlertId = this.alertId
      this.form.OwnerId = this.userId
      //this.form.Month = 
      this.form.Reduce = this.reduce
      this.form.Percent = this.percent
      this.form.Amount = this.goal
      this.form.Times = this.times
      this.form.GenType = this.genType

      this.form.SessionId = this.$store.state.session.SessionId
      this.form.action = "GenerateMilestones"
      axios.post(this.$apiUrl,
      qs.stringify(this.form),
      {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      })
      .then(response => {
        if(response.status == 200){ 
          this.getMilestoneOptions(response.data)
          this.$q.notify({ message: this.$t('global.MilestoneGenerated'), type: 'positive'})
        }
        else{
            this.$q.notify('Something Wrong.')
        }
      })
      .catch(e => {
        this.$q.notify('Something Wrong.')
        console.log(e); 
      })
    },
    dateFormat(val) {
      return date.formatDate(val, this.$store.state.session.DateFormat) 
    },
    calcGoal(){
      if(this.baseline != null){
        var val = this.percent
        if(this.reduce){
          val = 0 - val
        }
        this.goal =  Math.round(this.baseline / 100 * val)
      }
    },
    setBase(){
      this.alertOptions.forEach(op => {
            if(op.value == this.alertId) {
              if(this.genType == "m"){
                this.baseline = op.lastMonth
              }
              if(this.genType == "w"){
                this.baseline = op.lastWeek
              }
            }          
      }) 
    },

    getAlertConfig(){
      this.form.SessionId = this.$store.state.session.SessionId
      this.form.action = "GetAlertConfigList"
      axios.post(this.$apiUrl,
      qs.stringify(this.form),
      {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      })
      .then(response => {
        if(response.status == 200){ 
          this.alertOptions = response.data
          
        }
        else{
            this.$q.notify('Something Wrong.')
        }
      })
      .catch(e => {
        this.$q.notify('Something Wrong.')
        console.log(e); 
      })
    },
    getUser(){
      this.form.SessionId = this.$store.state.session.SessionId
      this.form.action = "GetUserList"
      axios.post(this.$apiUrl,
      qs.stringify(this.form),
      {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      })
      .then(response => {
        if(response.status == 200){ 
          this.ownerOptions = response.data
        }
        else{
            this.$q.notify('Something Wrong.')
        }
      })
      .catch(e => {
        this.$q.notify('Something Wrong.')
        console.log(e); 
      })
    },
    getMilestoneDetail(){
      this.form.SessionId = this.$store.state.session.SessionId
      this.form.action = "GetMilestoneDetail"
      this.form.MilestoneID = this.mileStoneId
      axios.post(this.$apiUrl,
      qs.stringify(this.form),
      {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      })
      .then(response => {
        if(response.status == 200){ 
          this.Milestone = response.data
        }
        else{
            this.$q.notify('Something Wrong.')
        }
      })
      .catch(e => {
        this.$q.notify('Something Wrong.')
        console.log(e); 
      })
    },
    getMilestoneOptions(mileStoneId){
      this.form.SessionId = this.$store.state.session.SessionId
      this.form.action = "GetMilestones"
      axios.post(this.$apiUrl,
      qs.stringify(this.form),
      {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      })
      .then(response => {
        if(response.status == 200){ 
          this.mileStoneOptions = []
          response.data.forEach(ms => {
              this.mileStoneOptions.push({value: ms.MileStoneID, label: ms.MilestoneName})
          }) 
          if(mileStoneId != null)
            this.mileStoneId = mileStoneId
        }
        else{
            this.$q.notify('Something Wrong.')
        }
      })
      .catch(e => {
        this.$q.notify('Something Wrong.')
        console.log(e); 
      })
    },
    deleteMilestone(){
    this.$q.dialog({
        title: this.$t('global.DeleteMilestone'),
        message: this.$t('global.QuestionDeleteMilestone'),
        cancel: true, 
      })
      .onOk(() => {   
        this.form.SessionId = this.$store.state.session.SessionId
        this.form.action = "DeleteMilestone"
        this.form.MilestoneID = this.mileStoneId
        axios.post(this.$apiUrl,
        qs.stringify(this.form),
        {
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        })
        .then(response => {
          if(response.status == 200){ 
            this.getMilestoneOptions()
            this.Milestone = []
            this.mileStoneId = null
            this.$q.notify({ message: this.$t('global.MilestoneDeleted'), type: 'positive'})
          }
          else{
              this.$q.notify('Something Wrong.')
          }
        })
        .catch(e => {
          this.$q.notify('Something Wrong.')
          console.log(e); 
        })
      })
      .onCancel(() => {
        //alert('Picked cancel')
      })
    },
    deleteMilestoneDetail(){
      this.$q.dialog({
        title: this.$t('global.DeleteMilestoneDetail'),
        message: this.$t('global.QuestionDeleteMilestoneDetail'),
        cancel: true, 
      })
      .onOk(() => {   
        this.form.SessionId = this.$store.state.session.SessionId
        this.form.action = "DeleteMilestoneDetail"
        this.form.MileStoneDetailID = this.selectedRows[0].MileStoneDetailID
        axios.post(this.$apiUrl,
        qs.stringify(this.form),
        {
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        })
        .then(response => {
          if(response.status == 200){ 
            this.getMilestoneOptions()
            this.Milestone = []
            this.$q.notify({ message: this.$t('global.MilestoneDetailDeleted'), type: 'positive'})
            this.getMilestoneDetail()
            this.selectedRows = []
          }
          else{
              this.$q.notify('Something Wrong.')
          }
        })
        .catch(e => {
          this.$q.notify('Something Wrong.')
          console.log(e); 
        })
      })
      .onCancel(() => {
        //alert('Picked cancel')
      })
    },
    editMilestoneDetail(){
      this.editStart = this.moment(this.selectedRows[0].Start)
      this.editEnding = this.moment(this.selectedRows[0].Ending)
      this.editGoal = this.selectedRows[0].Goal
      this.editDialog = true
    },
    updateMilestoneDetail(){
      this.editDialog = false
      this.form.SessionId = this.$store.state.session.SessionId
      this.form.action = "UpdateMilestoneDetail"
      this.form.MileStoneDetailID = this.selectedRows[0].MileStoneDetailID
      this.form.Start = this.editStart.toISOString()
      this.form.Ending = this.editEnding.toISOString()
      this.form.Goal = this.editGoal

      axios.post(this.$apiUrl,
      qs.stringify(this.form),
      {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      })
      .then(response => {
        if(response.status == 200){ 
          this.getMilestoneDetail()
          this.$q.notify({ message:'Milestone Upated', type: 'positive'})
        }
        else{
            this.$q.notify('Something Wrong.')
        }
      })
      .catch(e => {
        this.$q.notify('Something Wrong.')
        console.log(e); 
      })
    },
  },
  watch: {
    genType: function (val) {
      if(val == "m"){
        this.times = 12
      }
      else{
        this.times = 52
      }
    },
    percent: function(val){
      this.calcGoal()
    },
    reduce: function(val){
      this.calcGoal()
    },
    baseline: function(val){
      this.calcGoal()
    },
    alertId: function(val){
      this.setBase()
    },
    genType: function(val){
      this.setBase()
    },
    mileStoneId: function(val){
       if(this.mileStoneId != null)
          this.getMilestoneDetail()
    }
  },
  computed: {
    isReady: function () {
      if(this.baseline != null && this.goal != null && this.alertId != null && this.userId != null && this.name != ""){
        if(this.genType == "m"){
          if(this.times > 0 && this.times <= 24){
            return true
          }
        }
        if(this.genType == "w"){
          if(this.times > 0 && this.times <= 52){
            return true
          }
        }
      }
      return false
    },
    btnText: function(){
      return this.$t('global.GenerateMilestoneWith', {nrDetails: this.times})
    },
  },
  mounted() {
    this.getAlertConfig()
    this.getUser()
    this.getMilestoneOptions(null)
  },  
}
</script>
<style scoped>
.content{
  padding: 5px;
}
.pageContent{
  padding: 10px;
}
.title{
  text-align: center;
  padding-top: 10px;
}
</style>
